import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './Toast'
import { useToast } from './use-toast'

type ToasterProps = {
  /**
   * トーストの自動クローズまでのミリ秒。未指定なら Radix 既定 (5000ms)。
   *
   * `Infinity` を渡すと Radix は自動クローズ用の `setTimeout` を**張らない**。
   * Storybook story (= vitest から実行される) では `Infinity` を渡すこと。
   * 5 秒のタイマーがテスト終了後まで残ると、jsdom 環境の破棄後に発火した
   * `handleClose` が `document.activeElement` を参照して
   * `ReferenceError: document is not defined` を投げ、全テストが pass していても
   * vitest プロセスが exit 1 になる (原因特定: issue #2470)。
   */
  duration?: number
}

export const Toaster = ({ duration }: ToasterProps = {}) => {
  const { toasts } = useToast()

  return (
    <ToastProvider duration={duration}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
